import { render, staticRenderFns } from "./InputSuggest.vue?vue&type=template&id=283fbd6e&scoped=true&"
import script from "./InputSuggest.vue?vue&type=script&lang=js&"
export * from "./InputSuggest.vue?vue&type=script&lang=js&"
import style0 from "./InputSuggest.vue?vue&type=style&index=0&id=283fbd6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283fbd6e",
  null
  
)

export default component.exports